import _pt from "prop-types";
import { IconCaretDown } from '@lmig/lmds-react-icons';
import { LoadingSpinner } from '@lmig/lmds-react-loading-spinner';
import React from 'react';
import { IconEvo } from './IconEvo';
export var SelectIcon = function SelectIcon(_ref) {
  var loadingIcon = _ref.loadingIcon,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    highlightType = _ref.highlightType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement("div", {
    className: "lm-Field-select--loadingIcon"
  }, loadingIcon || /*#__PURE__*/React.createElement(LoadingSpinner, {
    hiddenTrack: true,
    color: "blue",
    size: "16"
  })) : /*#__PURE__*/React.createElement(IconCaretDown, {
    className: "lmig-Icon-classic",
    color: "gray",
    size: "16"
  }), /*#__PURE__*/React.createElement(IconEvo, {
    loading: loading,
    disabled: disabled,
    highlightType: highlightType
  }));
};
SelectIcon.propTypes = {
  loadingIcon: _pt.node,
  loading: _pt.bool,
  disabled: _pt.bool,
  highlightType: _pt.oneOf(['error'])
};